<template>
	<div class="container-evaluation-question">
		<ja-input
			v-model="simulationTemplate.templateName"
			:label="$t('templateName')"
			:name="$t('templateName')"
		></ja-input>
		<ja-dropdown
			v-model="simulationTypeIndex"
			:label="$t('simulationType')"
			:disabled="!isEditable"
			:options="simulationTypeOptions"
			name="simulationType"
		></ja-dropdown>
		<ja-dropdown
			v-if="isAdvancedSimulation(simulationTemplate.simulationType)"
			v-model="startLifeStageIndex"
			:label="$t('startLifeStage')"
			:disabled="!isEditable"
			:options="startLifeStageOptions"
			name="startLifeStage"
		></ja-dropdown>
		<ja-dropdown
			v-if="isAdvancedSimulation(simulationTemplate.simulationType)"
			v-model="endLifeStageIndex"
			:label="$t('endLifeStage')"
			:disabled="!isEditable"
			:options="endLifeStageOptions"
			name="endLifeStage"
		></ja-dropdown>
		<div class="box-businesses">
			<div class="option-businesses" :style="{ 'margin-bottom': '25px' }">
				<input
					v-model="selectedAll"
					type="checkbox"
					class="checkbox"
					name="selectedAll"
					:disabled="!isEditable"
				/>
				<label class="heading-5" for="selectedAll">{{
					$t('selectedAll')
				}}</label>
			</div>
			<div
				v-for="(option, index) in simulationTemplate.businesses"
				:key="index"
			>
				<div class="option-businesses">
					<input
						type="checkbox"
						class="checkbox"
						:name="option.name"
						:disabled="!isEditable"
						:checked="isBusinessSelected(option.expenseCategory_ID)"
						@change="handleBusinessSelection(option, $event.target.checked)"
					/>
					<label class="heading-5" :for="option.name">
						{{ option.name }}
					</label>
				</div>
				<div
					v-if="
						option.assetName.toLowerCase() ===
							loanApplicableCategories.TRANSPORTATION
					"
				>
					<div
						v-for="(loan, loanIndex) in filteredLoans(
							loanApplicableCategories.TRANSPORTATION
						)"
						:key="'transportation_' + loanIndex"
						class="option-businesses option-loans"
					>
						<input
							type="checkbox"
							class="checkbox"
							:name="loan.name"
							:disabled="!isEditable"
							:checked="isBusinessSelected(loan.expenseCategory_ID)"
							@change="handleBusinessSelection(loan, $event.target.checked)"
						/>
						<span class="heading-5">{{ loan.name }}</span>
					</div>
				</div>
				<div
					v-if="
						option.assetName.toLowerCase() === loanApplicableCategories.HOUSING
					"
				>
					<div
						v-for="(loan, loanIndex) in filteredLoans(
							loanApplicableCategories.HOUSING
						)"
						:key="'housing_' + loanIndex"
						class="option-businesses option-loans"
					>
						<input
							type="checkbox"
							class="checkbox"
							:disabled="!isEditable"
							:name="loan.name"
							:checked="isBusinessSelected(loan.expenseCategory_ID)"
							@change="handleBusinessSelection(loan, $event.target.checked)"
						/>
						<span class="heading-5">{{ loan.name }}</span>
					</div>
				</div>
			</div>
		</div>

		<div class="container-buttons save">
			<ja-button
				name="save"
				class="small outlined"
				:disabled="!isSaveEnable"
				@click.native="saveSimulationTemplate"
				>{{ $t('save') }}</ja-button
			>
			<ja-button name="cancel" class="small" @click.native="cancel">{{
				$t('cancel')
			}}</ja-button>
		</div>
	</div>
</template>
<script>
import { Dropdown, Input } from '@/components/ui/form';
import Button from '@/components/ui/Button';
import {
	ID_NEW_CMS,
	simulationTypeArray,
	loanApplicableCategories,
	lifeStageDropdown
} from '@/helpers/constants';
import '@/components/icons/cms/search';
import '@/components/icons/cms/pencil';
import '@/components/icons/cms/trash';

export default {
	components: {
		jaDropdown: Dropdown,
		jaButton: Button,
		jaInput: Input
	},
	props: {
		dataEdit: {
			type: Object,
			default: null,
			required: false
		}
	},
	data() {
		return {
			simulationTemplate: null,
			simulationTypeIndex: 0,
			endLifeStageIndex: 0,
			startLifeStageIndex: 0,
			selectedAll: false,
			simulationTypeOptions: simulationTypeArray,
			loanApplicableCategories: loanApplicableCategories,
			startLifeStageOptions: [],
			endLifeStageOptions: [
				{
					name: 'Teenager',
					displayOrder: 0,
					isActive: true,
					startLifeStage_ID: this.dataEdit.startLifeStage_ID
				},
				{
					name: 'Young Adult',
					displayOrder: 1,
					isActive: true,
					startLifeStage_ID: this.dataEdit.startLifeStage_ID
				},
				{
					name: 'Working Adult',
					displayOrder: 2,
					isActive: true,
					startLifeStage_ID: this.dataEdit.startLifeStage_ID
				},
				{
					name: 'Adult Nearing Retirement',
					displayOrder: 3,
					isActive: true,
					startLifeStage_ID: this.dataEdit.startLifeStage_ID
				}
			]
		};
	},
	computed: {
		isSaveEnable() {
			return this.simulationTemplate.templateName !== null;
		},
		isEditable() {
			return this.simulationTemplate.upperSimulationTemplate_ID === ID_NEW_CMS;
		}
	},
	watch: {
		simulationTypeIndex(newValue) {
			this.simulationTemplate.simulationType = this.simulationTypeOptions[
				newValue
			].id;
		},
		startLifeStageIndex(newValue) {
			this.simulationTemplate.startLifeStage_ID =
				lifeStageDropdown[newValue].lifeStage_ID;

			this.simulationTemplate.endLifeStage.startLifeStage_ID =
				lifeStageDropdown[newValue].lifeStage_ID;

			this.simulationTemplate.startLifeStage = this.startLifeStageOptions[
				newValue
			];

			if (newValue > this.endLifeStageIndex) {
				this.endLifeStageIndex = newValue;
			}
		},
		endLifeStageIndex(newValue, oldValue) {
			this.simulationTemplate.endLifeStage = this.endLifeStageOptions[newValue];

			if (this.startLifeStageIndex === 1 && newValue === 0) {
				this.endLifeStageIndex = oldValue || 1;
			}
			this.simulationTemplate.endLifeStage_ID =
				lifeStageDropdown[this.endLifeStageIndex].lifeStage_ID;
		},
		selectedAll(newValue) {
			if (newValue) {
				const allsID = this.simulationTemplate.businesses.map(
					b => b.expenseCategory_ID
				);
				const loansID = this.simulationTemplate.loans.map(
					loan => loan.expenseCategory_ID
				);

				allsID.push(...loansID);
				this.simulationTemplate.selectedBusinesses = allsID;
			} else {
				this.simulationTemplate.selectedBusinesses = [];
			}
		}
	},
	created() {
		this.simulationTemplate = this.dataEdit;
		const [firstLifeStage, secondLifeStage] = lifeStageDropdown;
		this.startLifeStageOptions = [
			{ ...firstLifeStage, isActive: true },
			{ ...secondLifeStage, isActive: true }
		];

		if (this.simulationTemplate.upperSimulationTemplate_ID === ID_NEW_CMS) {
			this.setCreateNew();
		} else {
			this.updateIndexQuestions();
		}
	},
	methods: {
		setCreateNew() {
			this.simulationTemplate.startLifeStage_ID = this.startLifeStageOptions[0].lifeStage_ID;

			this.simulationTemplate.endLifeStage_ID =
				lifeStageDropdown[0].lifeStage_ID;

			this.endLifeStageOptions.forEach(option => {
				option.startLifeStage_ID = this.simulationTemplate.startLifeStage_ID;
			});

			this.simulationTemplate.startLifeStage = this.startLifeStageOptions[0];

			this.simulationTemplate.endLifeStage = this.endLifeStageOptions[0];
		},
		isAdvancedSimulation(simulationTypeId) {
			return simulationTypeArray.some(
				type => type.id === simulationTypeId && type.name.includes('Advanced')
			);
		},
		updateIndexQuestions() {
			this.simulationTypeIndex =
				simulationTypeArray[this.simulationTemplate.simulationType].id;

			this.startLifeStageIndex = this.startLifeStageOptions.findIndex(
				option => option.name === this.simulationTemplate.startLifeStage.name
			);
			if (this.startLifeStageIndex === -1) {
				this.startLifeStageIndex = 0;
			}
			this.endLifeStageIndex = this.endLifeStageOptions.findIndex(
				option => option.name === this.simulationTemplate.endLifeStage.name
			);
			if (this.endLifeStageIndex === -1) {
				this.endLifeStageIndex = 0;
			}
		},
		filteredLoans(type) {
			if (type.toLowerCase() === loanApplicableCategories.TRANSPORTATION) {
				return this.simulationTemplate.loans.filter(loan =>
					loan.assetName.toLowerCase().includes('auto')
				);
			} else if (type.toLowerCase() === loanApplicableCategories.HOUSING) {
				return this.simulationTemplate.loans.filter(loan =>
					loan.assetName.toLowerCase().includes('mortgage')
				);
			}
			return [];
		},
		isBusinessSelected(expenseCategory_ID) {
			return this.simulationTemplate.selectedBusinesses.includes(
				expenseCategory_ID
			);
		},
		handleBusinessSelection(option, checked) {
			if (checked) {
				this.simulationTemplate.selectedBusinesses.push(
					option.expenseCategory_ID
				);

				if (
					option.assetName.toLowerCase() === loanApplicableCategories.HOUSING ||
					option.assetName.toLowerCase() ===
						loanApplicableCategories.TRANSPORTATION
				) {
					const loans = this.filteredLoans(option.assetName);
					const expenseCategoryIDs = loans.map(loan => loan.expenseCategory_ID);
					this.simulationTemplate.selectedBusinesses.push(
						...expenseCategoryIDs
					);
				}
			} else {
				if (
					option.assetName.toLowerCase() === loanApplicableCategories.HOUSING ||
					option.assetName.toLowerCase() ===
						loanApplicableCategories.TRANSPORTATION
				) {
					const loans = this.filteredLoans(option.assetName);
					const expenseCategoryIDs = loans.map(loan => loan.expenseCategory_ID);
					expenseCategoryIDs.forEach(id => {
						const index = this.simulationTemplate.selectedBusinesses.indexOf(
							id
						);
						if (index !== -1) {
							this.simulationTemplate.selectedBusinesses.splice(index, 1);
						}
					});
				}

				const index = this.simulationTemplate.selectedBusinesses.indexOf(
					option.expenseCategory_ID
				);
				if (index !== -1) {
					this.simulationTemplate.selectedBusinesses.splice(index, 1);
				}
			}
		},
		saveSimulationTemplate() {
			this.$emit('saveSimulationTemplate', this.simulationTemplate);
		},
		cancel() {
			this.$emit('cancel');
		}
	}
};
</script>
<style lang="scss" scoped>
.container-evaluation-question {
	display: flex;
	flex-direction: column;
	gap: 20px;
}
.container-buttons {
	margin: 15px 0 10px 0;
	display: flex;
	align-items: center;
	gap: 20px;
}
.questions {
	justify-content: flex-start;
}
.save {
	justify-content: flex-end;
}
.box-businesses {
	border: 1px solid $button-border;
	width: 50%;
	height: 250px;
	padding: 15px;
	overflow: auto;
}
.option-businesses {
	display: flex;
	gap: 10px;
	margin: 5px;
}
.heading-5 {
	color: $font-dark;
}
.text-button {
	color: $link-font-color;
}
.text-label {
	margin: 10px 0 10px 0;
}
.option-loans {
	margin-left: 30px;
}
</style>
